<template>
    <div class="py-5">
        <div v-if="Array.isArray(files) && files.length">
            <div class="hidden md:grid grid-cols-6 gap-2 p-2 font-medium border-b bg-gray-100">
                <div>
                    Tên file
                </div>
                <div>
                    Ngày tạo
                </div>
                <div>
                    Tác vụ
                </div>
                <div>
                    Tạo bởi
                </div>
                <div>
                    Xem file
                </div>
                <div>
                    Hành động
                </div>
            </div>
            <template
                v-for="(file, index) in files"
                :key="index">
                <!-- Desktop Row -->
                <div class="hidden md:grid grid-cols-6 gap-2 p-2 border-b items-center">
                    <div class="truncate">
                        <hts-tooltip reference-class="truncate">
                            <span>
                                {{ file.originalName || file.fileOriginName || file.fileName }}
                            </span>
                            <template #reference>
                                <span class="truncate">
                                    {{ file.originalName || file.fileOriginName || file.fileName }}
                                </span>
                            </template>
                        </hts-tooltip>
                    </div>
                    <div>
                        {{ $formatters.datetime(file.createdAt) }}
                    </div>
                    <div>
                        {{ file.taskName || 'Khác' }}
                    </div>
                    <div>
                        <hts-user
                            :id="file.createdBy"
                            inline
                            size="mini" />
                    </div>
                    <div>
                        <a
                            :href="$formatters.cdnUrl(file.path)"
                            target="_blank">
                            <img
                                v-if="file.mimeType && file.mimeType.includes('image')"
                                :src="$formatters.cdnUrl(file.path)"
                                class="max-h-20 max-w-full shadow border rounded" >
                            <span
                                v-else
                                class="underline text-blue-500">
                                Mở file
                            </span>
                        </a>
                    </div>
                    <div class="flex gap-2">
                        <button
                            class="text-blue-500 hover:text-blue-800"
                            @click="downloadFile(file)">
                            <hi-arrow-down-tray-icon class="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <!-- Mobile Card -->
                <div class="block md:hidden p-3 border rounded shadow mt-2 space-y-2">
                    <div>
                        <span class="font-semibold">
                            Tên file:
                        </span>
                        <span>
                            {{ file.originalName || file.fileOriginName || file.fileName }}
                        </span>
                    </div>
                    <div>
                        <span class="font-semibold">
                            Ngày tạo:
                        </span>
                        {{ $formatters.datetime(file.createdAt) }}
                    </div>
                    <div>
                        <span class="font-semibold">
                            Tác vụ:
                        </span>
                        {{ file.taskName || 'Khác' }}
                    </div>
                    <div>
                        <span class="font-semibold">
                            Tạo bởi:
                        </span>
                        <hts-user
                            :id="file.createdBy"
                            inline
                            size="mini" />
                    </div>
                    <div>
                        <a
                            :href="file.url"
                            target="_blank">
                            <img
                                v-if="file.mimeType && file.mimeType.includes('image')"
                                :src="file.url"
                                class="max-h-20 max-w-full shadow border rounded" >
                            <span
                                v-else
                                class="underline text-blue-500">
                                Mở file
                            </span>
                        </a>
                    </div>
                    <div class="flex gap-4 pt-2 border-t mt-2">
                        <button
                            class="text-blue-500 hover:text-blue-800 flex items-center gap-1"
                            @click="downloadFile(file)">
                            <hi-arrow-down-tray-icon class="h-5 w-5" /><span>
                                Tải về
                            </span>
                        </button>
                    </div>
                </div>
            </template>
        </div>
        <div v-else>
            No documents.
        </div>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  files: {
    type: Array as PropType<any>
  }
})

const downloadFile = async (file: any) => {
  if (!file || !file.url) {
    return
  }

  const name = file.originalName || file.fileOriginName || file.fileName || 'downloaded_file'

  try {
    const response = await fetch(file.url)
    const blob = await response.blob()
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Download failed:', error)
  }
}
</script>
